import { useCallback } from 'react'
import { useCubeData } from './useCubeData'
import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'

export const useStartDate = () => {
  const ctx = useCubeContext()
  const { data } = useCubeData()

  const setStartDate = useCallback(
    (newDate: Date) => {
      ctx.mutators.updateData({
        common: {
          startDate: newDate
        }
      })
    },
    [ctx.mutators]
  )

  return {
    startDate: data.common.startDate,
    setStartDate
  }
}
